export const typography = {
  h1: "clamp(2.4rem, 4vw, 3.6rem)",
  h2: "clamp(2rem, 3vw, 2.6rem)",
  h3: "1.35rem",
  body: "1rem",
  bodyLarge: "1.1rem",
  small: "0.85rem"
};

const shared = {
  typography,
  borderRadius: {
    pill: "999px",
    lg: "24px",
    md: "18px",
    sm: "12px"
  }
};

export const lightTheme = {
  name: "light",
  background: "#f7f9fb",
  surface: "#ffffff",
  text: "#1b2130",
  muted: "#5f6b7a",
  accent: "#2ACCC3",
  accentContrast: "#073836",
  border: "rgba(91, 112, 131, 0.15)",
  navBg: "rgba(247, 249, 251, 0.85)",
  navShadow: "0 10px 30px rgba(12, 22, 34, 0.08)",
  ...shared
};

export const darkTheme = {
  name: "dark",
  background: "#0f1117",
  surface: "#151923",
  text: "#f3f4f8",
  muted: "#9aa4b7",
  accent: "#2ACCC3",
  accentContrast: "#062e2c",
  border: "rgba(138, 155, 173, 0.18)",
  navBg: "rgba(15, 17, 23, 0.9)",
  navShadow: "0 12px 32px rgba(0, 0, 0, 0.45)",
  ...shared
};
